import React, {ReactElement, useCallback} from 'react';
import Tooltip from '@mui/material/Tooltip';
import {Chip, Divider, Stack} from '@mui/material';
import ColorizeIcon from '@mui/icons-material/Colorize';
import Avatar from '@mui/material/Avatar';
import * as Icons from '@mui/icons-material';

export const StatusCell = ({props}: { props: any }): ReactElement => {

  const getFieldContent = useCallback(() => {
    if (props.value?.name === undefined) {
      return {
        element: props.value?.id,
        tooltipValue: props.value?.id,
      };
    }

    if (props.value?.color && typeof props.value?.color === 'string') {
      return {
        element: (
          <Chip
            style={{background: props.value.color, color: '#fff'}}
            icon={<ColorizeIcon fontSize="small" sx={{color: 'white'}}/>}
            label={props.value.color}
          />
        ),
        tooltipValue: props.value.color,
      };
    }

    if (
      props.value?.color &&
      typeof props.value?.color === 'object' &&
      !props.value?.status_lamp
    ) {
      return {
        element: (
          <Chip
            style={{background: props.value.color.color, color: '#fff'}}
            label={props.value.name}
          />
        ),
        tooltipValue: props.value.name,
      };
    }

    if (props.value?.icon === null && !props.value?.status_lamp) {
      const IconComponent = Icons[props.value.name as keyof typeof Icons];
      return {
        element: (
          <Chip
            variant="outlined"
            style={{color: '#666'}}
            icon={IconComponent ? <IconComponent/> : undefined}
            label={props.value.name}
          />
        ),
        tooltipValue: props.value.name,
      };
    }

    // =========================
    // STATUS LAMP LOGIKA
    // =========================
    if (props.value?.status_lamp) {
      if (props.value?.icon) {
        const tooltipBlocks: React.ReactNode[] = [];

        // status_log
        if (props.row?.status_log?.length) {
          tooltipBlocks.push(
            <Stack key="logs">
              {[...props.row.status_log]
                .reverse()
                .map((item: any, index: number) => (
                  <span key={`log-${index}`}>{item}</span>
                ))}
            </Stack>
          );
        }

        // dátum, ha nincs log
        if (
          !props.row?.status_log?.length &&
          props.row?.service_reservation_status_updated_at
        ) {
          tooltipBlocks.push(
            <span key="date">
              {props.value.name} - {props.row.service_reservation_status_updated_at}
            </span>
          );
        }

        // COMMON status_messages
        if (props?.field !=='status' && props.row?.status_messages?.length) {

          tooltipBlocks.push(
            <Stack
              key="status-messages"
              sx={{
                mt: '5px'
              }}
            >
              <span>Group Infos</span>
              <Stack
                sx={{
                  background: 'rgba(74,74,74,0.83)',
                  p: '5px',
                  borderRadius: '5px'
                }}
              >
                {props.row.status_messages.map((item: any, index: number) => (
                  <span
                    key={`status-${index}`}
                    style={{
                      paddingLeft: `${(item?.tab || 0) * 20}px`,
                      display: 'block',
                    }}
                  >
                  {item}
                </span>
                ))}
              </Stack>
              <Divider/>
            </Stack>
          );
        }

        // activity_status_messages
        if (props?.field !=='status' && props.row?.activity_status_messages?.length) {

          tooltipBlocks.push(
            <Stack key="activity-messages"
                   sx={{
                     mt: '5px'
                   }}
            >
              <span>Activity Infos</span>
              <Stack
                sx={{
                  background: 'rgba(74,74,74,0.83)',
                  p: '5px',
                  borderRadius: '5px'
                }}
              >
                {props.row.activity_status_messages.map((item: any, index: number) => (
                  <span
                    key={`activity-${index}`}
                    style={{
                      paddingLeft: `${(item?.tab || 0) * 20}px`,
                      display: 'block',
                    }}
                  >
                  {item}
                </span>
                ))}
              </Stack>
              <Divider/>
            </Stack>
          );
        }

        // accommodation_status_messages
        if (props.row?.accommodation_status_messages?.length) {
          tooltipBlocks.push(
            <Stack key="accommodation-messages"
                   sx={{
                     mt: '5px'
                   }}
            >
              <span>Accommodation Infos</span>
              <Stack
                sx={{
                  background: 'rgba(74,74,74,0.83)',
                  p: '5px',
                  borderRadius: '5px'
                }}
              >
                {props.row.accommodation_status_messages.map((item: any, index: number) => (
                  <span
                    key={`accommodation-${index}`}
                    style={{
                      paddingLeft: `${(item?.tab || 0) * 20}px`,
                      display: 'block',
                    }}
                  >
                  {item}
                </span>
                ))}
              </Stack>
              <Divider/>
            </Stack>
          );
        }


        // warning reasons felülírhat
         if (props.row?.warning_reasons && (props.value?.id === 7 || props.value?.id === 8 || props.value?.id === 2)) {

           tooltipBlocks.push(
             <Stack key="warning-messages"
                    sx={{
                      mt: '5px'
                    }}
             >
               <span>Warnings</span>
               <Stack
                 sx={{
                   background: 'rgba(74,74,74,0.83)',
                   p: '5px',
                   borderRadius: '5px'
                 }}
               >
                 {props.row.warning_reasons.map((item: any, index: number) => (
                   <span
                     key={`warning-${index}`}
                     style={{
                       paddingLeft: `${(item?.tab || 0) * 20}px`,
                       display: 'block',
                     }}
                   >
                  {item}
                </span>
                 ))}
               </Stack>
               <Divider/>
             </Stack>
           );

           /*tooltipValue = (
             <>
               {props.row.warning_reasons.map((item: any, index: number) => (
                 <p key={index}>{item}</p>
               ))}
             </>
           );*/
         }

        let tooltipValue: any = props.value.name;

        if (tooltipBlocks.length > 0) {
          tooltipValue = <Stack>{tooltipBlocks}</Stack>;
        }


        const IconComponent =
          Icons[props.value.icon.name as keyof typeof Icons];

        return {
          element: (
            <Avatar
              sx={{
                background: props.value.color.color,
                width: 20,
                height: 20,
                '& .MuiSvgIcon-root': {fontSize: '16px'},
              }}
            >
              {IconComponent ? <IconComponent/> : null}
            </Avatar>
          ),
          tooltipValue,
        };
      }

      return {
        element: (
          <div
            className="fill-div h-full"
            style={{background: props.value.color.color}}
          />
        ),
        tooltipValue: props.value.name,
      };
    }

    return {
      element: (
        <div className="overflow-hidden text-ellipsis whitespace-nowrap">
          <div
            style={{
              color: props.value.color?.color ? '#fff' : '',
              background: props.value.color?.color,
            }}
          >
            {props.value.name}
          </div>
        </div>
      ),
      tooltipValue: props.value.name,
    };
  }, [props]);

  const fieldContent = getFieldContent();

  return (
    <Stack alignItems="center" justifyContent="center">
      <Tooltip
        disableInteractive
        title={fieldContent.tooltipValue}
        sx={{maxWidth: 700}}
        slotProps={{
          tooltip: {
            sx: {fontSize: '13px', maxWidth: 700},
          },
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {offset: [0, -14]},
              },
            ],
          },
        }}
      >
        <div>{fieldContent.element}</div>
      </Tooltip>
    </Stack>
  );
};